import {useTemplateBuilder} from "./context";
import {browserStyle, browserTextStyle} from "./fields";
import type {BlockStyle, InputBinding, InputKind} from "./types";
import {findInputDefinition} from "./variables";

export const InputPreview = ({ input, kind, style }: { input: InputBinding; kind: InputKind; style?: BlockStyle | string }) => {
  const { inputDefinitions } = useTemplateBuilder();
  const definition = findInputDefinition(inputDefinitions, input.actor, input.inputId);
  if (!definition) return <p>Missing input definition.</p>;
  const choices = definition.options ?? [];
  const textStyle = browserTextStyle(style);
  return <section className="template-builder-input-preview" style={browserStyle(style)}>
    <strong style={textStyle}>{definition.label}</strong>
    {kind === "checkbox" ? <div className="template-builder-preview-choice" style={textStyle}><span aria-hidden="true" />Yes</div> : null}
    {kind === "radio" || kind === "choice" ? <div className="template-builder-preview-choices">
      {choices.map((option) => <div className={`template-builder-preview-choice ${kind === "radio" ? "template-builder-preview-radio" : ""}`} key={option.id} style={textStyle}>
        <span aria-hidden="true" />{option.label}
      </div>)}
    </div> : null}
    {kind === "textarea" ? <div className="template-builder-preview-textarea" aria-hidden="true" /> : null}
    {kind === "text" ? <div className="template-builder-preview-text" aria-hidden="true" /> : null}
  </section>;
};
